import React from 'react';
import { useNavigate } from 'react-router-dom';
import Heading from '../components/common/Typography/Heading';
import Paragraph from '../components/common/Typography/Paragraph';
import MainButton from '../components/common/MainButton/MainButton';

const CheckoutCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-2xl w-full mx-4 bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="fi fi-rs-cross-circle text-2xl text-yellow-500"></i>
          </div>
          
          <Heading variant="h3" className="mb-4">Checkout Cancelled</Heading>
          
          <Paragraph className="mb-6">
            Your checkout process was cancelled. No charges have been made to your account.
            Would you like to try again or explore our other plans?
          </Paragraph>

          <div className="space-y-4">
            <MainButton
              variant="extralarge"
              onClick={() => navigate('/pricing')}
              className="w-full"
            >
              View Plans Again
            </MainButton>
            
            <MainButton
              variant="extralarge"
              onClick={() => navigate('/dashboard')}
              className="w-full bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              Return to Dashboard
            </MainButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutCancel; 